function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js'; // width="30px" height="22px"

const defaultSize = '20px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const setHeight = ({
  size,
  height
}) => height || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "media__SVG",
  componentId: "sc-1q5b0ml-0"
})(["width:", ";height:", ";"], setWidth, setHeight);
export default (({
  fill,
  ...rest
}) => /*#__PURE__*/React.createElement(SVG, _extends({
  viewBox: "0 0 30 22"
}, rest, {
  fill: fill
}), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_media-frostbite",
  stroke: "#5F636D"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  strokeWidth: "1.2",
  x: "1.41",
  y: "0.67",
  width: "24.81",
  height: "18.29"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  strokeWidth: "0.4",
  points: "28.84 3.29 28.84 21.58 4.03 21.58"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  strokeWidth: "0.4",
  points: "18.98 8.12 14.98 8.12 16.98 5.12"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  strokeWidth: "0.4",
  points: "26.22 18.96 1.42 18.96 6.34 11.8 9.1 11.8 10.82 14.32 14.98 8.12 18.98 8.12"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.41,0.67 C6.41,3.43142375 4.17142375,5.67 1.41,5.67",
  id: "Path",
  strokeWidth: "0.4"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  strokeWidth: "0.4",
  points: "9.1 11.8 6.34 11.8 7.7 9.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.34,11.8 L1.42,18.96",
  id: "Path",
  strokeWidth: "0.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.7,18.96 L14.98,8.12",
  id: "Path",
  strokeWidth: "0.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.66,0.42 C8.66,0.59 8.66,0.76 8.66,0.92",
  id: "Path",
  strokeWidth: "0.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.27,2.84 C7.40345519,5.37327244 5.25535628,7.25476333 2.63,7.78",
  id: "Path",
  strokeWidth: "0.4",
  strokeDasharray: "0.98"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.66,7.91 L1.16,7.91",
  id: "Path",
  strokeWidth: "0.4"
})))));